module.exports = __webpack_public_path__ + "static/media/Tips_and_Tools-Device_Lookup.599a34f8.svg";